import { Component, Input } from '@angular/core';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {

  @Input () public classes: string = '';
  @Input () public show: boolean = false;
  @Input () public text: boolean = true;
  @Input () public label: string = 'general.labels.loading';

  /**
   * Constructor
   */
  public constructor() { }

}
